// Данные блока «О компании».
export const aboutStats = [
  { value: "19+", label: "лет на рынке климата" },
  { value: "500+", label: "сданных объектов" },
  { value: "30+", label: "инженеров и монтажников" },
  { value: "1 год", label: "гарантии на работы" },
];

export const aboutPoints = [
  {
    title: "Полный цикл под ключ",
    text: "Проектируем, поставляем оборудование, монтируем и обслуживаем — вы работаете с одним подрядчиком от идеи до запуска.",
  },
  {
    title: "Свои инженеры и монтажники",
    text: "Не нанимаем бригады со стороны: работы выполняет штатная команда с профильным опытом и допусками.",
  },
  {
    title: "Работаем по договору",
    text: "Фиксируем смету, сроки и гарантию в договоре. Без скрытых доплат и переделок за ваш счёт.",
  },
  {
    title: "Официальные поставки",
    text: "Поставляем оборудование напрямую от производителей с гарантией и сервисной поддержкой.",
  },
];
